/**
 * Service checkout guard
 * - Pending flag set when a service CTA clears cart + redirects to /checkout
 * - On return to the storefront without paying, strip any pending service lines
 *   so they never block small preset checkouts.
 * - Always resync the header cart badge (bfcache / back from checkout leaves
 *   stale Liquid HTML even when /cart.js is already empty).
 */
(function () {
  'use strict';

  var FLAG = 'bento_service_checkout_pending';
  var PROP = '_bento_service';
  var running = false;

  function readFlag() {
    try {
      var raw = sessionStorage.getItem(FLAG);
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function clearFlag() {
    try {
      sessionStorage.removeItem(FLAG);
    } catch (e) {}
  }

  function refreshUi() {
    if (window.BentoCartAddFlow && typeof window.BentoCartAddFlow.refreshBag === 'function') {
      window.BentoCartAddFlow.refreshBag();
    } else if (window.CartDrawer && typeof window.CartDrawer.refreshBag === 'function') {
      window.CartDrawer.refreshBag();
    }
  }

  function applyCartIconSection(sectionHtml) {
    var link = document.getElementById('cart-icon-bubble');
    if (!link || !sectionHtml) return;
    try {
      var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
      var root = doc.querySelector('.shopify-section') || doc.body;
      if (!root) return;
      link.innerHTML = root.innerHTML;
    } catch (e) {}
  }

  function syncCartIconFromCount(count) {
    var link = document.getElementById('cart-icon-bubble');
    if (!link) return;
    count = parseInt(count, 10) || 0;
    var bubble = link.querySelector('.cart-count-bubble');
    if (count <= 0) {
      if (bubble) bubble.remove();
      return;
    }
    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      bubble.innerHTML =
        '<span aria-hidden="true"></span>' +
        '<span class="visually-hidden">Cart items</span>';
      link.appendChild(bubble);
    }
    var num = bubble.querySelector('[aria-hidden="true"]');
    if (num) num.textContent = String(count < 100 ? count : '');
  }

  function fetchAndApplyCartIcon() {
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    return fetch(cartUrl + '?section_id=cart-icon-bubble', {
      credentials: 'same-origin'
    })
      .then(function (r) {
        if (!r.ok) throw new Error('section');
        return r.text();
      })
      .then(applyCartIconSection)
      .catch(function () {});
  }

  function afterCartChange(cart) {
    var count = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
    syncCartIconFromCount(count);
    var sectionHtml = cart && cart.sections && cart.sections['cart-icon-bubble'];
    var iconReady = sectionHtml
      ? Promise.resolve().then(function () {
          applyCartIconSection(sectionHtml);
        })
      : fetchAndApplyCartIcon();

    return iconReady.then(function () {
      refreshUi();
      try {
        if (typeof publish === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'bento-service-checkout',
            cartData: cart || { item_count: count, items: [] }
          });
        }
      } catch (e) {}
    });
  }

  function stripPendingServices() {
    var flag = readFlag();
    if (!flag || running) return;
    running = true;

    fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart');
        return r.json();
      })
      .then(function (cart) {
        var updates = {};
        var found = false;
        var items = (cart && cart.items) || [];
        var variantId = flag.variantId ? parseInt(flag.variantId, 10) : 0;

        for (var i = 0; i < items.length; i++) {
          var item = items[i];
          var props = item.properties || {};
          var isService =
            props[PROP] === '1' ||
            props[PROP] === 1 ||
            (variantId && item.variant_id === variantId);

          if (isService) {
            updates[item.key] = 0;
            found = true;
          }
        }

        clearFlag();

        if (!found) {
          // Cart already empty (or lines already gone) but bfcache HTML may
          // still show the old badge — force a icon/badge resync.
          return afterCartChange(cart);
        }

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          credentials: 'same-origin',
          body: JSON.stringify({
            updates: updates,
            sections: ['cart-icon-bubble'],
            sections_url: window.location.pathname
          })
        }).then(function (r) {
          if (!r.ok) throw new Error('update');
          return r.json();
        }).then(function (data) {
          return afterCartChange(data);
        });
      })
      .catch(function () {
        clearFlag();
        syncCartIconFromCount(0);
        return fetchAndApplyCartIcon();
      })
      .finally(function () {
        running = false;
      });
  }

  window.BentoServiceCheckout = {
    markPending: function (variantId) {
      try {
        sessionStorage.setItem(
          FLAG,
          JSON.stringify({
            variantId: variantId || null,
            at: Date.now()
          })
        );
      } catch (e) {}
    },
    clearPending: clearFlag,
    sweep: stripPendingServices
  };

  window.addEventListener('pageshow', function () {
    stripPendingServices();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', stripPendingServices);
  } else {
    stripPendingServices();
  }
})();
